import { render } from "./kritHeader.vue?vue&type=template&id=4f847a3c"
import script from "./kritHeader.vue?vue&type=script&lang=js"
export * from "./kritHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__